import React from 'react'
import {useState,useEffect} from "react"
import { axiosInstance } from "../axios/Axios";
import {Link} from "react-router-dom";
import ListGroup from 'react-bootstrap/ListGroup';
import { useNavigate } from "react-router-dom";

const Existing = () => {

    const [data,setData] = useState(null);

    const [submitted,setSubmitted] = useState(null);
    const [loading,setLoading] = useState(false);
    const [toast, setToast] = useState(true);

    const navigate = useNavigate();    

    useEffect(() => {

        axiosInstance.get('survey/list/')
            .then((res) => {
                setData(res.data)
            })

    },[])

    if (data===null)    
        return <div>Loading</div>

    if("msg" in data && data["msg"]==="error occured")
        return <div>Error</div>

    var list = data.map((d)=>{
        
        return <ListGroup.Item
                className="d-flex justify-content-between align-items-start" style={{margin:"10px"}}>
                    {d.title}
                    <div style={{padding:"5px 10px"}}>
                        <Link style={{paddingRight:" 20px"}} to={"/response/" + d.gid + '/'}>Visit</Link>
                        <Link style={{paddingRight:" 20px"}} to={"/edit/" + d.gid + '/'}>Edit</Link>    
                        
                        <Link style={{paddingRight:" 20px"}} onClick={()=>{
                            axiosInstance.get('survey/train/'+d.gid+'/')
                            .then((res) => {
                                console.log(res.data)
                            })
                        }} >Train</Link>
                        <Link to={"/analyse/" + d.gid + '/'}>Analyse</Link>
                    </div>
                </ListGroup.Item>
            
    })

    return (
        <div className="container">                                
            <div className='display-1' style={{padding:"40px"}}>
                Existing Surveys
            </div>
            <div className="row justify-content-center">
                <div className="col-md-8 ">
                <ListGroup>
                    {list}
                </ListGroup>
                </div>
            </div>
        
        </div>
    )
}

export default Existing
